const PROMOTIONS_ONBOARD_KEY = 'onboardingPromotions';
const PROMOTION_ONBOARD_KEY = 'onboardingPromotionDetail';
const PROMOTION_POST_KEY = 'onboardingPromotionsPost';
const REGISTER_ONBOARD_KEY = 'onboardingRegisterKey';
const FAVORITE_ONBOARD_KEY = 'onboardingFavoriteKey';

const TRIGGER_PATH = '_show_step_';
const SHOW_PATH = '_active';

const showWithTags = [PROMOTIONS_ONBOARD_KEY, PROMOTION_ONBOARD_KEY];

const generateTriggerClass = (popupName: string, step: number): string => popupName + TRIGGER_PATH + step;

export {
  PROMOTIONS_ONBOARD_KEY,
  REGISTER_ONBOARD_KEY,
  FAVORITE_ONBOARD_KEY,
  TRIGGER_PATH,
  SHOW_PATH,
  generateTriggerClass,
  PROMOTION_ONBOARD_KEY,
  PROMOTION_POST_KEY,
  showWithTags,
};
